(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-carousel"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('custom-hero-carousel')) {

    class CustomHeroCarousel extends HTMLElement {

      constructor() {
        super();

        this.currentSlide = 0;
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
        this.autoplayTimer = null;
      }


      connectedCallback() {

        this.track = this.querySelector('[data-hero-track]');
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];

        this.previousButton = this.querySelector('[data-hero-previous]');
        this.nextButton = this.querySelector('[data-hero-next]');

        this.dots = [
          ...this.querySelectorAll('[data-hero-dot]')
        ];

        if (!this.track || this.slides.length <= 1) {
          return;
        }


        this.setupNavigation();
        this.setupTouch();
        this.setupAutoplay();

      }


      disconnectedCallback() {
        this.stopAutoplay();
      }


      setupNavigation() {

        if (this.previousButton) {
          this.previousButton.addEventListener(
            'click',
            () => {
              this.previousSlide();
            }
          );
        }


        if (this.nextButton) {
          this.nextButton.addEventListener(
            'click',
            () => {
              this.nextSlide();
            }
          );
        }


        this.dots.forEach((dot) => {

          dot.addEventListener(
            'click',
            () => {

              const index = Number(
                dot.dataset.heroDot
              );

              this.goToSlide(index);

            }
          );

        });

      }


      setupTouch() {

        this.track.addEventListener(
          'touchstart',
          (event) => {

            this.stopAutoplay();

            this.startX =
              event.touches[0].clientX;

            this.isDragging = true;

          },
          {
            passive: true
          }
        );


        this.track.addEventListener(
          'touchmove',
          (event) => {

            if (!this.isDragging) {
              return;
            }

            this.currentX =
              event.touches[0].clientX;

          },
          {
            passive: true
          }
        );


        this.track.addEventListener(
          'touchend',
          () => {

            if (!this.isDragging) {
              return;
            }


            const difference =
              this.currentX - this.startX;


            if (Math.abs(difference) > 50) {

              if (difference < 0) {
                this.nextSlide();
              } else {
                this.previousSlide();
              }

            }


            this.isDragging = false;
            this.startAutoplay();

          }
        );

      }


      nextSlide() {

        const nextIndex =
          this.currentSlide + 1 >= this.slides.length
            ? 0
            : this.currentSlide + 1;


        this.goToSlide(nextIndex);

      }


      previousSlide() {

        const previousIndex =
          this.currentSlide - 1 < 0
            ? this.slides.length - 1
            : this.currentSlide - 1;


        this.goToSlide(previousIndex);

      }


      goToSlide(index) {

        this.currentSlide = index;

        this.track.style.transform =
          `translate3d(-${index * 100}%, 0, 0)`;


        this.dots.forEach(
          (dot, dotIndex) => {

            const isActive =
              dotIndex === index;


            dot.classList.toggle(
              'is-active',
              isActive
            );


            dot.setAttribute(
              'aria-current',
              isActive ? 'true' : 'false'
            );

          }
        );


        this.restartAutoplay();

      }


      setupAutoplay() {

        const autoplayEnabled =
          this.dataset.autoplay === 'true';


        if (!autoplayEnabled) {
          return;
        }


        this.addEventListener(
          'mouseenter',
          () => this.stopAutoplay()
        );


        this.addEventListener(
          'mouseleave',
          () => this.startAutoplay()
        );


        this.startAutoplay();

      }


      startAutoplay() {

        const autoplayEnabled =
          this.dataset.autoplay === 'true';


        if (!autoplayEnabled) {
          return;
        }


        this.stopAutoplay();


        const speed =
          Number(
            this.dataset.autoplaySpeed
          ) || 5;


        this.autoplayTimer =
          setInterval(
            () => {
              this.nextSlide();
            },
            speed * 1000
          );

      }


      stopAutoplay() {

        if (this.autoplayTimer) {

          clearInterval(
            this.autoplayTimer
          );

          this.autoplayTimer = null;

        }

      }


      restartAutoplay() {

        const autoplayEnabled =
          this.dataset.autoplay === 'true';


        if (!autoplayEnabled) {
          return;
        }


        this.stopAutoplay();
        this.startAutoplay();

      }

    }


    customElements.define(
      'custom-hero-carousel',
      CustomHeroCarousel
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
